import {AbstractControl, ValidationErrors} from "@angular/forms";

export class PasswordConfirmationValidator {
  static validatePasswordMatch(controlName: string, matchingControlName: string): ValidationErrors | null {
    return (group: AbstractControl) => {
      const control = group.get(controlName);
      const matchingControl = group.get(matchingControlName);

      if (!control || !matchingControl) {
        return null;
      }

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        return null;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({mustMatch: true});
      }
      else {
        matchingControl.setErrors(null);
      }
      return null;
    }
  }
}
